export const ACTIVE_BRANCH_ID_KEY = 'activeBranchId';
export const ACTIVE_BRANCH_NAME_KEY = 'activeBranchName';
export const ACTIVE_BRANCH_COUNTRY_ID_KEY = 'activeBranchCountryId';
export const ACTIVE_BRANCH_USER_ID_KEY = 'activeBranchUserId';

export const ACTIVE_BRANCH_SESSION_EVENT = 'activeBranchSessionChange';

const parseNumber = (raw: string | null): number | null => {
  if (raw === null || raw === '') return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getActiveBranchIdFromSession = (): number | null =>
  parseNumber(sessionStorage.getItem(ACTIVE_BRANCH_ID_KEY));

export const getActiveBranchNameFromSession = (): string | null =>
  sessionStorage.getItem(ACTIVE_BRANCH_NAME_KEY);

export const getActiveBranchCountryIdFromSession = (): number | null =>
  parseNumber(sessionStorage.getItem(ACTIVE_BRANCH_COUNTRY_ID_KEY));

export const getActiveBranchUserIdFromSession = (): number | null =>
  parseNumber(sessionStorage.getItem(ACTIVE_BRANCH_USER_ID_KEY));

export type ActiveBranchSessionUpdate = {
  activeBranchId?: number | null;
  activeBranchName?: string | null;
  activeBranchCountryId?: number | null;
  // Владелец сессии вкладки: значения филиала действительны только для этого
  // пользователя (перелогин под другим профилем их не наследует).
  activeBranchUserId?: number | null;
};

const writeOrRemove = (key: string, value: number | string | null) => {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
};

const notifyActiveBranchSessionChange = () => {
  window.dispatchEvent(new Event(ACTIVE_BRANCH_SESSION_EVENT));
};

export const setActiveBranchSession = (update: ActiveBranchSessionUpdate) => {
  if ('activeBranchId' in update) {
    writeOrRemove(ACTIVE_BRANCH_ID_KEY, update.activeBranchId ?? null);
  }
  if ('activeBranchName' in update) {
    writeOrRemove(ACTIVE_BRANCH_NAME_KEY, update.activeBranchName ?? null);
  }
  if ('activeBranchCountryId' in update) {
    writeOrRemove(
      ACTIVE_BRANCH_COUNTRY_ID_KEY,
      update.activeBranchCountryId ?? null
    );
  }
  if ('activeBranchUserId' in update) {
    writeOrRemove(ACTIVE_BRANCH_USER_ID_KEY, update.activeBranchUserId ?? null);
  }
  notifyActiveBranchSessionChange();
};

export const clearActiveBranchSession = () => {
  sessionStorage.removeItem(ACTIVE_BRANCH_ID_KEY);
  sessionStorage.removeItem(ACTIVE_BRANCH_NAME_KEY);
  sessionStorage.removeItem(ACTIVE_BRANCH_COUNTRY_ID_KEY);
  sessionStorage.removeItem(ACTIVE_BRANCH_USER_ID_KEY);
  notifyActiveBranchSessionChange();
};

export const subscribeActiveBranchSession = (callback: () => void) => {
  window.addEventListener(ACTIVE_BRANCH_SESSION_EVENT, callback);
  return () => {
    window.removeEventListener(ACTIVE_BRANCH_SESSION_EVENT, callback);
  };
};
